import $ from 'jquery';
import './vendor/jquery.magnific-popup.1.1.0.min.js';
import { Engine, Render, World, Common, Bodies } from 'matter-js';

window.CABLELABS_GLOBALS.template_directory_uri += '/btp/images/';

// video popup
var url = $('#mission-video').attr('src');

$('.mission-video-wrapper').magnificPopup({
    fixedContentPos: true,
    fixedBgPos: true,
    overflowY: 'auto',
    type:'inline',
    midClick: true,
    callbacks: {
        beforeOpen: function() {
            $('body').addClass('mfp-zoom-out-cur');
            $('#mission-video').attr('src', url + '&autoplay=1');
        },
        beforeClose: function() {
            $('body').removeClass('mfp-zoom-out-cur');
            $('#mission-video').attr('src', null);
        }
    }
});

// flip board member cards randomly
// adapted from https://codepen.io/aishaghazanfar/pen/qdjVWa

// cache vars
var cards = document.querySelectorAll(".board-images__single");
var timeMin = 2;
var timeMax = 20;
var timeouts = [];

// loop through cards
for ( var i = 0, len = cards.length; i < len; i++ ) {
  var card = cards[i];
  var cardID = card.getAttribute("data-id");
  var id = "timeoutID" + cardID;
  var time = randomNum( timeMin, timeMax ) * 8000;
  cardsTimeout( id, time, card );
}

// timeout listener
function cardsTimeout( id, time, card ) {
  if (id in timeouts) {
    clearTimeout(timeouts[id]);
  }
  timeouts[id] = setTimeout( function() {
    var c = card.classList;
    var newTime = randomNum( timeMin, timeMax ) * 8000;
    c.contains("flipped") === true ? c.remove("flipped") : c.add("flipped");
    cardsTimeout( id, newTime, card );
  }, time );
}

// random number generator given min and max
function randomNum( min, max ) {
  return Math.random() * (max - min) + min;
}



// render ACF google map for event location single page
if ($('.js-about-map').length) {
    /*
    *  new_map
    */
    function new_map( $el ) {
    	// var
    	var $markers = $el.find('.marker');
    	// vars
    	var args = {
            backgroundColor: '#EDEDED',
            zoom		: 16,
    		center		: new google.maps.LatLng(0, 0),
    		mapTypeId	: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            streetViewControl: false,
            mapTypeControl: false,
            rotateControl: false,
            fullscreenControl: false
    	};
    	// create map
    	var map = new google.maps.Map( $el[0], args);
    	// add a markers reference
    	map.markers = [];
    	// add markers
    	$markers.each(function(){
        	add_marker( $(this), map );
    	});
    	// center map
    	center_map( map );
        // style map
        styleMap(map);
    	// return
    	return map;
    }

    /*
    *  add styles
    */
   function styleMap(map) {
     // establish styles
     var styles = [
          {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#e9e9e9"
                  },
                  {
                      "lightness": 17
                  }
              ]
          },
          {
              "featureType": "landscape",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#f5f5f5"
                  },
                  {
                      "lightness": 20
                  }
              ]
          },
          {
              "featureType": "road.highway",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#ffffff"
                  },
                  {
                      "lightness": 17
                  }
              ]
          },
          {
              "featureType": "road.highway",
              "elementType": "geometry.stroke",
              "stylers": [
                  {
                      "color": "#ffffff"
                  },
                  {
                      "lightness": 29
                  },
                  {
                      "weight": 0.2
                  }
              ]
          },
          {
              "featureType": "road.arterial",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#ffffff"
                  },
                  {
                      "lightness": 18
                  }
              ]
          },
          {
              "featureType": "road.local",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#ffffff"
                  },
                  {
                      "lightness": 16
                  }
              ]
          },
          {
              "featureType": "poi",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#f5f5f5"
                  },
                  {
                      "lightness": 21
                  }
              ]
          },
          {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#dedede"
                  },
                  {
                      "lightness": 21
                  }
              ]
          },
          {
              "elementType": "labels.text.stroke",
              "stylers": [
                  {
                      "visibility": "on"
                  },
                  {
                      "color": "#ffffff"
                  },
                  {
                      "lightness": 16
                  }
              ]
          },
          {
              "elementType": "labels.text.fill",
              "stylers": [
                  {
                      "saturation": 36
                  },
                  {
                      "color": "#333333"
                  },
                  {
                      "lightness": 40
                  }
              ]
          },
          {
              "elementType": "labels.icon",
              "stylers": [
                  {
                      "visibility": "off"
                  }
              ]
          },
          {
              "featureType": "transit",
              "elementType": "geometry",
              "stylers": [
                  {
                      "color": "#f2f2f2"
                  },
                  {
                      "lightness": 19
                  }
              ]
          },
          {
              "featureType": "administrative",
              "elementType": "geometry.fill",
              "stylers": [
                  {
                      "color": "#fefefe"
                  },
                  {
                      "lightness": 20
                  }
              ]
          },
          {
              "featureType": "administrative",
              "elementType": "geometry.stroke",
              "stylers": [
                  {
                      "color": "#fefefe"
                  },
                  {
                      "lightness": 17
                  },
                  {
                      "weight": 1.2
                  }
              ]
          }
      ];

      // apply them to the map
      var styledMap = new google.maps.StyledMapType(styles,{name: "Styled Map"});
      map.mapTypes.set('map_style', styledMap);
      map.setMapTypeId('map_style');
    }

    /*
    *  add_marker
    */

    function add_marker( $marker, map ) {
    	// var
    	var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    	// create marker
    	var marker = new google.maps.Marker({
    		position	: latlng,
    		map			: map,
            icon        : window.CABLELABS_GLOBALS.template_directory_uri + 'map/map-marker.png'// urls defined in the php as variable
    	});
    	// add to array
    	map.markers.push( marker );
    	// if marker contains HTML, add it to an infoWindow
    	if( $marker.html() ) {
    		// create info window
    		var infowindow = new google.maps.InfoWindow({
    			content		: $marker.html()
    		});
    		// show info window when marker is clicked
    		google.maps.event.addListener(marker, 'click', function() {
                $('.gm-style-iw').parent().hide();
    			infowindow.open( map, marker );
    		});
    	}
    }

    /*
    *  center_map
    */

    function center_map( map ) {

        var allowedBounds = new google.maps.LatLngBounds(
        	new google.maps.LatLng(60, -130),	// top left corner of map
        	new google.maps.LatLng(-60, 130)	// bottom right corner
        );

        var k = 5.0;
        var n = allowedBounds.getNorthEast().lat() - k;
        var e = allowedBounds.getNorthEast().lng() - k;
        var s = allowedBounds.getSouthWest().lat() + k;
        var w = allowedBounds.getSouthWest().lng() + k;
        var neNew = new google.maps.LatLng( n, e );
        var swNew = new google.maps.LatLng( s, w );
        var boundsNew = new google.maps.LatLngBounds( swNew, neNew );
        map.fitBounds(boundsNew);

    }

    /*
    *  document ready
    */
    // global var
    var map = null;

    $(document).ready(function(){
      $.getScript('https://maps.googleapis.com/maps/api/js?key=AIzaSyBeOPb_zNTL_BCDqXUfZQMB5UBpoyd2EOE')
        .done(function( script, textStatus ) {
          $('.js-about-map').each(function(){
            // create map
            map = new_map( $(this) );
          });
        });
    });

}

(function(){
  // create engine
  var engine = Engine.create(),
      world = engine.world;

  var windowWidth = window.innerWidth,
      circleSize,
      lightBulbCircleImage,
      paperCircleImage;

  // create canvas element
  var render = Render.create({
      element: document.getElementById('patents'),
      engine: engine,
      options: {
          width: Math.round(windowWidth),
          height: 1500,
          background: 'transparent',
          showAngleIndicator: false,
          wireframes: false
      }
  });

  Render.run(render);


  // add walls to hold circles
  var options = {
      isStatic: true,
      render: {
          fillStyle: 'transparent'
      }
  };

  World.add(world, [
      Bodies.rectangle( // bottom wall
          575,
          1520,
          10000,
          50.5,
          options
      ),
      Bodies.rectangle( // right wall
          Math.round(windowWidth),
          0,
          10,
          10000,
          options
      ),
      Bodies.rectangle( // left wall
          0,
          300,
          10,
          10000,
          options
      )
  ]);


  function dropCircles(){
      var callCount = 0 ;
      var dropBalls = setInterval(function(){
          World.add(engine.world, addCircle());
          if (++ callCount  == 80) {
               clearInterval(dropBalls);
          }
      }, 30);
  }

  if (windowWidth < 1000) { // serve smaller elements to fit area better
      lightBulbCircleImage = window.CABLELABS_GLOBALS.template_directory_uri + 'light-bulb-circle-sm.png';
      paperCircleImage = window.CABLELABS_GLOBALS.template_directory_uri + 'paper-circle-sm.png';
      circleSize = 21;
  } else {
      lightBulbCircleImage = window.CABLELABS_GLOBALS.template_directory_uri + 'light-bulb-circle.png';
      paperCircleImage = window.CABLELABS_GLOBALS.template_directory_uri + 'paper-circle.png';
      circleSize = 40;
  }

  var addCircle = function () {
       if (Common.random() > 0.40) {
          return Bodies.circle(
              Math.round( (windowWidth / 3) * 2), // where along the x-axis this circle will be placed,
                                                  // just about 2/3 of the way to the right
              Math.floor(Math.random() * -160) + -100, // where along the y axis this circle will be placed,
                                                      // randomly between -100 and -160 pixels above the top of the canvas
                                                      // so they are out of view when they are created
              circleSize,
              {
                  density: 0.8,
                  friction: 0.01,
                  frictionAir: 0.001,
                  restitution: 0.3,
                  render: {
                      strokeStyle: '#ffffff',
                      sprite: {
                          texture: paperCircleImage
                      }
                  }
              }
          )
       } else {
          return Bodies.circle(
              Math.round( (windowWidth / 3) * 2), // where along the x-axis this circle will be placed,
                                                  // just about 2/3 of the way to the right
              Math.floor(Math.random() * -160) + -100, // where along the y axis this circle will be placed,
                                                      // randomly between -100 and -160 pixels above the top of the canvas
                                                      // so they are out of view when they are created
              circleSize,
              {
                  density: 0.8,
                  friction: 0.01,
                  frictionAir: 0.001,
                  restitution: 0.3,
                  render: {
                      sprite: {
                          texture: lightBulbCircleImage
                      }
                  }
              }
          )
       }
  };

  // throttle scrolling and run engine
  var scrollTimeout,
      throttle = 50,
      extraScrollPosition = 1600,
      distance = $('#patents').offset().top,
      $window = $(window);

  var ballDropListenerFunction = function () {
      if (!scrollTimeout) {
          scrollTimeout = setTimeout(function () {
              scrollTimeout = null;
              if ((($window.scrollTop() + $window.height() + extraScrollPosition) >= (distance / 2))) {
                  Engine.run(engine);
                  dropCircles();
                  window.removeEventListener('scroll', ballDropListenerFunction);
              }
          }, throttle);
      }
  };

  window.addEventListener('scroll', ballDropListenerFunction);
})();
